<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3>{{ 'SELLERS.FILTER_CTA' | translate }}</h3>

    <form
      [formGroup]="sellers_filter_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.NAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="seller_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.SELLER_ID_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="seller_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.PHONE_VALUE_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="phone_value"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.EMAIL_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="email"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'SELLERS.CONFIRMED_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="is_confirmed"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="green">
            <mat-icon
              [ngClass]="'sp-color__green'"
              [matTooltip]="'GENERAL.TOOLTIP_CONFIRMED' | translate">
              check_circle
            </mat-icon>
            {{ 'SELLERS.CONFIRMED_GREEN_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="orange">
            <mat-icon
              [ngClass]="'sp-color__orange'"
              [matTooltip]="'GENERAL.TOOLTIP_NOT_CONFIRMED_PASSWORD_SET' | translate">
              check_circle
            </mat-icon>
            {{ 'SELLERS.CONFIRMED_ORANGE_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="red">
            <mat-icon
              [ngClass]="'sp-color__red'"
              [matTooltip]="'GENERAL.TOOLTIP_NOT_CONFIRMED_NO_PASSWORD' | translate">
              check_circle
            </mat-icon>
            {{ 'SELLERS.CONFIRMED_RED_LABEL' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
